// Ameersha N : 27-11-2023 : BT-116461 Breeze - Addendum and Notices --Start
import { memo, useMemo, useRef } from 'react';
import { BzMasterAgGrid, BzModal, BzModalBody, BzModalHeader } from '../../components';
import { Col, Container, Row } from 'react-bootstrap';
import moment from 'moment';
import { ADDENDUM_STATUS_MODAL_REF, setAddendumStatusModalGridRef } from '../../utils/global_functions';

const AddendDumReportStatusModal = ({ isOpen, selectedRowData, handleOnHide }) => {

    setAddendumStatusModalGridRef(useRef());
    // Ameersha N : 17-11-2023 : BT-116461 Breeze - Addendum and Notices --Start
    const addenndumNoticesColDef = useMemo(() => [
        { field: 'status', headerName: 'STATUS', flex: 1, width: '50%', filter: 'agTextColumnFilter' },
        {
            field: 'entered_date', headerName: 'DATE & TIME', flex: 1, width: '50%', filter: 'agDateColumnFilter', filterParams: {
                comparator: (dateFromFilter, cellValue) => {
                    if (cellValue === null) { return -1; }
                    const dateParts = moment(cellValue).format('DD/MM/YYYY')?.split('/');
                    const cellDate = new Date(Number(dateParts[2]), Number(dateParts[1]) - 1, Number(dateParts[0]));
                    if (dateFromFilter?.getTime() === cellDate?.getDate()) {
                        return 0;
                    }
                    if (cellDate < dateFromFilter) {
                        return -1;
                    } else
                        if (cellDate > dateFromFilter) {
                            return 1;
                        }
                    return 0;
                }
            }
        },
    ], []);
    // Ameersha N : 17-11-2023 : BT-116461 Breeze - Addendum and Notices --End


    // Ameersha N : 17-11-2023 : BT-116461 Breeze - Addendum and Notices --Start
    const arrAddendumRowData = useMemo(() => selectedRowData?.notice_summary, [selectedRowData]);
    // Ameersha N : 17-11-2023 : BT-116461 Breeze - Addendum and Notices --End
    
    return (
        <BzModal show={isOpen} onHide={handleOnHide} className='modal-breeze p-3'>
            <BzModalHeader className='bdr-none'>
                {selectedRowData?.notice_title?.length > 0 &&
                    <Container fluid className='p-0'>
                        <Row className='g-0 pt-3 pb-2 bdr-btm'>
                            <Col className='d-flex justify-content-center'>
                                <div className='font-medium font-size4 color-text'>{selectedRowData?.notice_title}</div>
                            </Col>
                        </Row>
                    </Container>
                }
            </BzModalHeader>
            <BzModalBody>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col>
                            {Object?.keys(selectedRowData)?.includes('field') && selectedRowData?.field === 'notice_title' ?
                                <div className='font-regular font-size2 color-text' dangerouslySetInnerHTML={{ __html: selectedRowData?.notice_desc }}></div> :
                                <BzMasterAgGrid
                                    ref={ADDENDUM_STATUS_MODAL_REF}
                                    isCompress={true}
                                    rowSelection='multiple'
                                    arrColumnData={addenndumNoticesColDef} arrRowData={arrAddendumRowData}
                                    rowHeight={36} className='ag-theme-alpine addendumnotice-modal-ag-grid-wrapper'
                                />
                            }
                        </Col>
                    </Row>
                </Container>
            </BzModalBody>
        </BzModal>
    );
};

export default memo(AddendDumReportStatusModal);
// Ameersha N : 27-11-2023 : BT-116461 Breeze - Addendum and Notices --End